export default "__VITE_ASSET__chTyPf26__"